"use strict";
// This is the same as the manager in the bar
// TODO: Combine all the client side shared code into a single package
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This class is responsible for managing the hotkey
 * and triggering the bar to open.
 *
 * It must only be initialized when we know we want to begin
 * listening for the hotkey because it will set itself up
 * automatically.
 *
 */
var HotKeyManager = /** @class */ (function () {
    function HotKeyManager(_a) {
        var key = _a.key, keyDidPress = _a.keyDidPress;
        /**
         * In order to make sure we can remove the event listener
         * we need to keep a reference to the bound function.
         *
         * https://stackoverflow.com/questions/14417890/does-bind-change-the-function-reference-how-to-set-permanently?lq=1
         */
        this.boundHandleKeyDown = this._handleKeyDown.bind(this);
        this.key = key;
        this.keyDidPress = keyDidPress;
        this._setup();
    }
    /**
     * This must be called to cleanup the hotkey listener
     * when the key changes or the state of the client changes.
     *
     */
    HotKeyManager.prototype.cleanup = function () {
        // Not sure if this check is needed by trying to account for SSR
        if (document) {
            document.removeEventListener("keydown", this.boundHandleKeyDown);
        }
    };
    // ==============================
    // Private methods
    // ==============================
    /**
     * Called automatically during initialization
     */
    HotKeyManager.prototype._setup = function () {
        // Not sure if this check is needed by trying to account for SSR
        if (document) {
            document.addEventListener("keydown", this.boundHandleKeyDown);
        }
    };
    /**
     * Handles the keydown event
     */
    HotKeyManager.prototype._handleKeyDown = function (event) {
        if (event.key === this.key) {
            var focusedElement = document.activeElement;
            if (!focusedElement ||
                (focusedElement.tagName !== "INPUT" &&
                    focusedElement.tagName !== "TEXTAREA" &&
                    focusedElement.getAttribute("contenteditable") !== "true") ||
                (focusedElement.tagName === "INPUT" &&
                    ["text", "password", "number", "email", "search", "tel", "url"].indexOf(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    focusedElement.type) === -1)) {
                // We need to stop the event from propagating so that
                // the bar doesn't open when we're typing in an input
                event.stopPropagation();
                event.preventDefault();
                event.stopImmediatePropagation();
                // Now we can actually callback to the parent
                this.keyDidPress();
            }
        }
    };
    return HotKeyManager;
}());
exports.default = HotKeyManager;
